import { lazy, Suspense, ComponentType } from 'react'
import { ErrorBoundary } from './ErrorBoundary'

interface ModuleLoaderProps {
  children: React.ReactNode
  moduleName: string
  fallback?: React.ReactNode
}

function ModuleLoader({ children, moduleName, fallback }: ModuleLoaderProps) {
  return (
    <ErrorBoundary moduleName={moduleName} fallback={fallback}>
      <Suspense
        fallback={fallback || (
          <div className="flex items-center justify-center min-h-[300px]">
            <div className="text-center">
              <div className="inline-block w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mb-3" />
              <p className="text-sm text-on-surface-variant">正在加载{moduleName}模块...</p>
            </div>
          </div>
        )}
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  )
}

const LazyLocalLifeAdmin = lazy(() =>
  import('./LocalLifeAdmin').then(m => ({ default: m.LocalLifeAdmin as unknown as ComponentType<any> }))
)

const LazyLocalLifeMerchantApp = lazy(() =>
  import('./LocalLifeMerchantApp').then(m => ({ default: m.LocalLifeMerchantApp as unknown as ComponentType<any> }))
)

const LazyLocalLifeUserApp = lazy(() =>
  import('./LocalLifeUserApp').then(m => ({ default: m.LocalLifeUserApp as unknown as ComponentType<any> }))
)

const LazyPropertyManagerApp = lazy(() =>
  import('./PropertyManagerApp').then(m => ({ default: m.PropertyManagerApp as unknown as ComponentType<any> }))
)

export function LocalLifeAdminLazy(props: any) {
  return (
    <ModuleLoader moduleName="本地生活管理">
      <LazyLocalLifeAdmin {...props} />
    </ModuleLoader>
  )
}

export function LocalLifeMerchantAppLazy(props: any) {
  return (
    <ModuleLoader moduleName="商户管理">
      <LazyLocalLifeMerchantApp {...props} />
    </ModuleLoader>
  )
}

export function LocalLifeUserAppLazy(props: any) {
  return (
    <ModuleLoader moduleName="用户端">
      <LazyLocalLifeUserApp {...props} />
    </ModuleLoader>
  )
}

export function PropertyManagerAppLazy(props: any) {
  return (
    <ModuleLoader moduleName="移动端物业">
      <LazyPropertyManagerApp {...props} />
    </ModuleLoader>
  )
}

export default ModuleLoader
